// Product Sticky ATC V2 - Custom Element
document.addEventListener('DOMContentLoaded', function () {
  (function () {
    if (!customElements.get('product-sticky-atc-v2')) {
      class ProductStickyAtcV2 extends HTMLElement {
        constructor() {
          super();
          this.variantPickerBlockId = null;
          this.intersectionObserver = null;
          this._isFooterVisible = false;
          this._isPaymentContainerPassed = false;
        }

        connectedCallback() {
          this.variantPickerBlockId = this.getAttribute('data-variant-picker-block-id');
          this._setupScrollToVariants();
          this._setupVisibilityObservers();

          // Listen for variant changes to update button state
          const formId = this.getAttribute('form-id');
          const form = document.getElementById(formId);
          if (form) {
            form.addEventListener('variant:changed', this._onVariantChanged.bind(this));
          }
        }

        disconnectedCallback() {
          if (this.intersectionObserver) {
            this.intersectionObserver.disconnect();
          }
        }

        set hidden(value) {
          this.toggleAttribute('hidden', value);
        }

        _setupScrollToVariants() {
          const selectButton = this.querySelector('[data-action="scroll-to-variants"]');
          if (!selectButton) return;

          selectButton.addEventListener('click', () => {
            this._scrollToVariantPicker();
          });
        }

        _scrollToVariantPicker() {
          // Try multiple selectors to find the variant picker
          let variantPickerElement = null;

          // Try by block ID first
          if (this.variantPickerBlockId) {
            variantPickerElement = document.getElementById(this.variantPickerBlockId);
          }

          // Fallback: try multiple selectors
          if (!variantPickerElement) {
            const selectors = [
              '[data-block-type="variant_picker"]',
              '.product-form__controls',
              '.product-variants',
              'product-variants',
              '.variant-picker',
              '[id*="variant"]',
              '.product-form .select-wrapper',
              '.shopify-section--main-product .select-wrapper'
            ];

            for (const selector of selectors) {
              variantPickerElement = document.querySelector(selector);
              if (variantPickerElement) break;
            }
          }

          if (variantPickerElement) {
            // Calculate position to center element in viewport
            const elementRect = variantPickerElement.getBoundingClientRect();
            const elementCenter = elementRect.top + (elementRect.height / 2);
            const viewportCenter = window.innerHeight / 2;
            const scrollOffset = elementCenter - viewportCenter;

            window.scrollTo({
              top: window.pageYOffset + scrollOffset,
              behavior: 'smooth'
            });

            // Optional: Focus on the first variant option for accessibility
            setTimeout(() => {
              const firstOption = variantPickerElement.querySelector('input, select, button');
              if (firstOption && typeof firstOption.focus === 'function') {
                firstOption.focus();
              }
            }, 500);
          } else {
            console.warn('Product Sticky ATC V2: Could not find variant picker element to scroll to');
          }
        }

        _setupVisibilityObservers() {
          // Find the main payment container (buy buttons)
          const paymentContainerElement = document.getElementById('MainPaymentContainer')?.closest('form') ||
                                          document.querySelector('.product-form') ||
                                          document.querySelector('[id*="product-form"]');

          const footerElement = document.querySelector('.shopify-section--footer') ||
                               document.querySelector('footer');

          const stickyHeaderOffset = this._getStickyHeaderOffset();

          if (!paymentContainerElement) {
            console.warn('Product Sticky ATC V2: Could not find payment container element');
            return;
          }

          this.intersectionObserver = new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                if (entry.target === footerElement) {
                  this._isFooterVisible = entry.intersectionRatio > 0;
                }
                if (entry.target === paymentContainerElement) {
                  const boundingRect = paymentContainerElement.getBoundingClientRect();
                  this._isPaymentContainerPassed = entry.intersectionRatio === 0 &&
                                                   boundingRect.top + boundingRect.height <= stickyHeaderOffset;
                }
              });

              this._updateVisibility();
            },
            {
              rootMargin: `-${stickyHeaderOffset}px 0px 0px 0px`,
              threshold: [0, 0.1, 1]
            }
          );

          this.intersectionObserver.observe(paymentContainerElement);
          if (footerElement) {
            this.intersectionObserver.observe(footerElement);
          }

          // Initial visibility check
          this._updateVisibility();
        }

        _updateVisibility() {
          // Show when:
          // 1. User has scrolled past the main payment container
          // 2. Footer is not visible
          this.hidden = !this._isPaymentContainerPassed || this._isFooterVisible;
        }

        _getStickyHeaderOffset() {
          // Calculate the offset from sticky header and announcement bar
          const header = document.querySelector('.shopify-section--header');
          const announcementBar = document.querySelector('.shopify-section--announcement');

          let offset = 0;

          if (header && getComputedStyle(header).position === 'sticky') {
            offset += header.offsetHeight;
          }

          if (announcementBar && getComputedStyle(announcementBar).position === 'sticky') {
            offset += announcementBar.offsetHeight;
          }

          return offset;
        }

        _onVariantChanged(event) {
          const variant = event.detail?.variant;
          if (!variant) return;

          // Update button disabled state
          const addButton = this.querySelector('.product-sticky-atc-v2__add-button');
          if (addButton) {
            if (variant.available) {
              addButton.removeAttribute('disabled');
              const buttonContent = addButton.getAttribute('data-button-content');
              if (buttonContent) {
                addButton.textContent = buttonContent;
              }
            } else {
              addButton.setAttribute('disabled', 'disabled');
              addButton.textContent = window.themeStrings?.soldOut || 'Sold out';
            }
          }
        }
      }

      customElements.define('product-sticky-atc-v2', ProductStickyAtcV2);
    }
  })();
});
